import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function Sales(props: SvgIconProps) {
  return (
    <SvgIcon height="125" viewBox="0 0 160 125" width="160" {...props}>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_7701_273"
          x1="109.511"
          x2="62.3945"
          y1="6.05403"
          y2="107.491"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F7FE" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_7701_273"
          x1="45.6132"
          x2="119.239"
          y1="66.6731"
          y2="66.6731"
        >
          <stop stopColor="#E1E9F7" />
          <stop offset="1" stopColor="#CCDAF3" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_7701_273"
          x1="45.6132"
          x2="119.239"
          y1="66.6731"
          y2="66.6731"
        >
          <stop stopColor="#E1E9F7" />
          <stop offset="1" stopColor="#CCDAF3" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_7701_273"
          x1="45.6132"
          x2="119.239"
          y1="66.6731"
          y2="66.6731"
        >
          <stop stopColor="#E1E9F7" />
          <stop offset="1" stopColor="#CCDAF3" />
        </linearGradient>
      </defs>
      <path
        d="M130.076 15.5987C100.085 0.265018 91.1004 28.8401 55.2396 6.90315C23.2379 -12.6689 8.6397 14.6476 4.52417 23.9011C-0.551442 35.3039 -8.03195 63.9899 24.6265 75.0946C66.4573 89.3156 64.2244 112.641 96.4794 122.579C122.342 130.546 146.103 119.114 157.221 84.3608C165.599 58.1728 154.6 28.1395 130.076 15.5987Z"
        fill="url(#paint0_linear_7701_273)"
      />
      <path
        d="M94.9996 39.0634L98.2894 31.8188L105.499 28.5639L98.2894 25.3091L94.9996 18.0645L91.7797 25.3091L84.5001 28.5639L91.7797 31.8188L94.9996 39.0634Z"
        fill="url(#paint1_linear_7701_273)"
      />
      <path
        d="M115.996 35.5652C110.922 35.5652 108.087 40.605 109.242 44.3498L96.8174 56.8092C95.7675 56.4942 94.2276 56.4942 93.1776 56.8092L84.2531 47.8846C85.443 44.1398 82.6081 39.0651 77.4984 39.0651C72.4237 39.0651 69.5538 44.1048 70.7437 47.8846L54.7846 63.8088C51.0397 62.6539 46 65.4887 46 70.5635C46 74.4133 49.1498 77.5631 52.9996 77.5631C58.0744 77.5631 60.9092 72.5234 59.7543 68.7786L75.6785 52.8194C76.7284 53.1343 78.2684 53.1343 79.3183 52.8194L88.2429 61.7439C87.0529 65.4887 89.8878 70.5635 94.9975 70.5635C100.072 70.5635 102.942 65.5237 101.752 61.7439L114.212 49.3195C117.956 50.4745 122.996 47.6396 122.996 42.5649C122.996 38.7151 119.846 35.5652 115.996 35.5652Z"
        fill="url(#paint2_linear_7701_273)"
      />
      <path
        d="M56.4995 39.0634L54.7496 46.063L52.9996 39.0634L46 37.3135L52.9996 35.5636L54.7496 28.5639L56.4995 35.5636L63.4991 37.3135L56.4995 39.0634Z"
        fill="url(#paint3_linear_7701_273)"
      />
    </SvgIcon>
  )
}

export default Sales
